export class BasicRequest{

    Token:string;
    CurrentYear:string;
    InstitutionNumber:string;    
    Action:string;
    Login:boolean;
}